<template lang="pug">
  article#about(v-once)
    h2 Privacidade
    h3 Versão de boas:
    h4 Sobre informações armazenadas
    p Para o correto funcionamento do site Toma.ae, nós precisamos coletar e armazenar alguns dados pertinentes à funcionalidade que oferecemos.
    p Para usuários anônimos, a única informação armazenada é o link a ser encurtado. Nenhuma informação sobre o usuário é armazenada.
    p Além disso, coletamos estatísticas de acesso quando alguém usa o seu link, como data e hora do acesso. Não coletamos nenhum dado que identifique quem acessa links através do nosso serviço.
    p Para usuários autenticados, nós precisamos armazenar dados que identifiquem o usuário em nosso sistema. Esses dados incluem seu nome, imagem e endereço de e-mail.
    h4 Sobre a divulgação/compartilhamento de informações armazenadas
    p Não divulgamos informações de usuários para terceiros. Ponto.
    p
      | No entanto, vale ressaltar que a autenticação é feita pelo Firebase Auth, um serviço do Google, e a&nbsp;
      a(href="https://www.google.com/policies/privacy/") política de privacidade deles
      |  deve ser levada em consideração.
    h3 Versão completa:
    h4 Em breve
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue